export enum Systems {
  QH = "http://quiltedhealth.com",
  LOINC = "http://loinc.org",
  ICD10CM = "http://hl7.org/fhir/sid/icd-10-cm",
  SNOMED = "http://snomed.info/sct",
  UOM = "http://unitsofmeasure.org",
  FHIR_VS = "http://hl7.org/fhir/ValueSet",
  FHIR_US_COMMON_LIBRARY = "http://hl7.org/fhir/us/vr-common-library/ValueSet",
  AllLanguages = "urn:ietf:bcp:47",
  IdentifierType = "http://terminology.hl7.org/CodeSystem/v2-0203",
  HL7PaymentType = "http://terminology.hl7.org/CodeSystem/payment-type",
  HL7ConditionClinical = "http://terminology.hl7.org/CodeSystem/condition-clinical",
  HL7ActReason = "http://terminology.hl7.org/CodeSystem/v3-ActReason",
  RXNORM = "http://www.nlm.nih.gov/research/umls/rxnorm",
  FHIR_TERMINOLOGY = "http://terminology.hl7.org",
  HL7DataOperation = "http://terminology.hl7.org/CodeSystem/v3-DataOperation",
  HL7ProvenanceParticipantType = "http://terminology.hl7.org/CodeSystem/provenance-participant-type",
  HL7ObservationCategory = "http://terminology.hl7.org/CodeSystem/observation-category",
  UsageContextType = "http://terminology.hl7.org/CodeSystem/usage-context-type",
  ACUITY_SCHEDULING = "https://acuityscheduling.com",
  SocialSecurity = "http://hl7.org/fhir/sid/us-ssn",
  V3ActCode = "http://terminology.hl7.org/CodeSystem/v3-ActCode",
  CoverageClass = "http://terminology.hl7.org/CodeSystem/coverage-class",
  HealthGorilla = "https://www.healthgorilla.com",
  HL7ObservationInterpretation = "http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation",
  HL7DiagnosticServiceSectionID = "http://terminology.hl7.org/CodeSystem/v2-0074",
  HealthGorillaObservationInterpretation = "https://www.healthgorilla.com/observation-interpretation",
  HL7InterpretationCodes = "http://terminology.hl7.org/CodeSystem/v2-0078",
  HL7NPI = "http://hl7.org/fhir/sid/us-npi",
  NUCCTaxonomy = "http://nucc.org/provider-taxonomy",
  HL7USCoreValueSet = "http://hl7.org/fhir/us/core/ValueSet",
  OrganizationType = "http://terminology.hl7.org/CodeSystem/organization-type",
  OrganizationRole = "http://hl7.org/fhir/organization-role",
  InvoiceIdentifier = "http://quiltedhealth.com/fhir/invoice-identifier",
  DotPhraseTriggerIdentifier = "http://quiltedhealth.com/fhir/dotphrase-trigger",
  LabCorpPractitionerAccountNumber = "http://quiltedhealth.com/fhir/CodeSystem/labcorp-practitioner-account-number",
  HelpScout = "https://secure.helpscout.net",
  InsurancePayerId = "https://www.joincandidhealth.com/chc-payerid",
  InsuranceClaimsPayerId = "https://www.joincandidhealth.com/availity-claims-payer-id",
  InsuranceEligibilityPayerId = "https://www.joincandidhealth.com/availity-eligibility-payer-id",
  V3RoleCode = "http://terminology.hl7.org/CodeSystem/v3-RoleCode",
}
